import { memo } from 'react';
import clsx from 'clsx';
import { NavLink } from 'react-router';

import { routesConfig } from '../../../routes.config';

import styles from './styles/footer.module.css';

interface Props {
	className?: string;
	classNameContainer?: string;
}

export default memo(Footer);

function Footer({ className, classNameContainer }: Props) {
	return (
		<footer className={clsx(styles['footer'], className)}>
			<div className={clsx(styles['footer-legal'])}>
				<div
					className={clsx(
						styles['footer-legal__container'],
						classNameContainer,
					)}
				>
					<nav className={clsx(styles['footer-legal__nav'])}>
						<ul className={clsx(styles['footer-legal__nav-list'])}>
							<li
								className={clsx(styles['footer-legal__nav-li'])}
							>
								<NavLink
									className={({ isActive }) =>
										clsx(
											styles['footer-legal__nav-link'],
											isActive
												? styles[
														'footer-legal__nav-link--active'
													]
												: null,
										)
									}
									to={`/${routesConfig.aboutClearGroup.path}`}
								>
									About "CLEAR" group
								</NavLink>
							</li>
							<li
								className={clsx(styles['footer-legal__nav-li'])}
							>
								<NavLink
									className={({ isActive }) =>
										clsx(
											styles['footer-legal__nav-link'],
											isActive
												? styles[
														'footer-legal__nav-link--active'
													]
												: null,
										)
									}
									to={`/${routesConfig.imprint.path}`}
									end
								>
									Imprint
								</NavLink>
							</li>
							<li
								className={clsx(styles['footer-legal__nav-li'])}
							>
								<NavLink
									className={({ isActive }) =>
										clsx(
											styles['footer-legal__nav-link'],
											isActive
												? styles[
														'footer-legal__nav-link--active'
													]
												: null,
										)
									}
									to={`/${routesConfig.dataProtectionAct.path}`}
									end
								>
									Data Protection Act
								</NavLink>
							</li>
						</ul>
					</nav>
				</div>
			</div>
		</footer>
	);
}
